import { PAY_DETAIL_FIELDS } from '../common/constants';

export const savePayFormatter = (values) => ({
  contractUuid: values[PAY_DETAIL_FIELDS.CONTRACT_UUID],
  amount: values[PAY_DETAIL_FIELDS.AMOUNT].substring(1).trim(),
  userUuid: values[PAY_DETAIL_FIELDS.USER_UUID],
  branchUuid: values[PAY_DETAIL_FIELDS.BRANCH_UUID],
});
